import { render, staticRenderFns } from "./flickity.vue?vue&type=template&id=1911da09"
import script from "./flickity.vue?vue&type=script&lang=js"
export * from "./flickity.vue?vue&type=script&lang=js"
import style0 from "flickity/dist/flickity.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../vue-loader@15.11.1_babel-core@6.26.3_css-loader@4.3.0_lodash@4.17.21_prettier@1.19.1_vue-temp_lls4wxv5ipnxzldxaoogv2ybrq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports